// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.my-back-img {\n  width: 20px;\n  height: 20px;\n  position: absolute;\n  top: 4px;\n  left: 2px;\n}\n", ""]);
// Exports
module.exports = exports;
